import { fetchPlayerGuardians } from '@/services/get-player-guardians';
import { useQuery } from '@tanstack/react-query';

export const playerGuardiansKeys = {
  all: ['player-guardians'] as const,
  list: (playerId?: string) => [...playerGuardiansKeys.all, playerId ?? null] as const,
};

/**
 * A player's co-guardian circle from
 * GET `/api/v1/guardians/me/players/{playerId}/guardians`. Gated on `playerId` so it
 * only fires once the player is known.
 */
export function usePlayerGuardiansQuery(playerId?: string) {
  return useQuery({
    queryKey: playerGuardiansKeys.list(playerId),
    queryFn: () => fetchPlayerGuardians(playerId as string),
    enabled: Boolean(playerId),
  });
}
